/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Delete_ButtonInputs */

const he_notifications_delete_button = /** @type {(inputs: Notifications_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בטל התראה למוצר זה`)
};

const en_notifications_delete_button = /** @type {(inputs: Notifications_Delete_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Notification`)
};

/**
* | output |
* | --- |
* | "Remove Notification" |
*
* @param {Notifications_Delete_ButtonInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_delete_button = /** @type {((inputs?: Notifications_Delete_ButtonInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Delete_ButtonInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_delete_button(inputs)
	return en_notifications_delete_button(inputs)
});